"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var FedopsLoggerWrapper = /** @class */ (function () {
    function FedopsLoggerWrapper(_a) {
        var _this = this;
        var logger = _a.logger, interactionsState = _a.interactionsState;
        this.createInteraction = function (name) {
            return {
                start: function () { return _this.interactionStarted(name); },
                end: function () { return _this.interactionEnded(name); },
            };
        };
        this.logger = logger;
        this.interactionsState = interactionsState;
    }
    FedopsLoggerWrapper.prototype.interactionStarted = function (name) {
        this.interactionsState.start(name);
        this.logger.interactionStarted(name);
        // tslint:disable-next-line:no-console
        // console.log(`started: ${name}`);
    };
    FedopsLoggerWrapper.prototype.interactionEnded = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.interactionsState.fetch()];
                    case 1:
                        _a.sent();
                        if (this.interactionsState.has(name)) {
                            this.logger.interactionEnded(name);
                            this.interactionsState.complete(name);
                            // tslint:disable-next-line:no-console
                            // console.log(`ended: ${name}`);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FedopsLoggerWrapper.prototype.appLoaded = function () {
        this.logger.appLoaded();
    };
    return FedopsLoggerWrapper;
}());
exports.FedopsLoggerWrapper = FedopsLoggerWrapper;
//# sourceMappingURL=loggerWrapper.js.map